import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Project } from '../classes/project.class';
import { User } from '../classes/user.class';
import { CodaltComponent } from '../codalt.component';
import { DAY_IN_MILLISECONDS, Utils } from '../utils.class';

export interface ShiftDateRangeDialogData {
    originalDate: string; // ISO date string
    project: Project; // Replace with actual project type
    executor: User; // Replace with actual executor type
}

export interface ShiftDateRangeDialogResult {
    newDate: string; // ISO date string
}

@Component({
    selector: 'app-shift-date-range-dialog',
    templateUrl: './shift-date-range-dialog.component.html',
    styleUrl: './shift-date-range-dialog.component.scss',
    standalone: false,
})
export class ShiftDateRangeDialogComponent extends CodaltComponent implements OnInit {
    dateControl = new FormControl(null);
    selectedDate: Date | null = null;
    daysDifference: number = 0;
    originalDateFormatted: string = '';
    newDateFormatted: string = '';
    Math = Math; // Expose Math to template

    constructor(
        private dialogRef: MatDialogRef<ShiftDateRangeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ShiftDateRangeDialogData
    ) {
        super();
    }

    ngOnInit(): void {
        this.originalDateFormatted = Utils.formatDate(this.data.originalDate, 'EEEE d MMMM', 'nl');
        this.dateControl.setValue(new Date(this.data.originalDate));

        console.log('Initial date value:', this.data);
        this.subscriptions.add(
            this.dateControl.valueChanges.subscribe(newDate => {
                if (newDate) {
                    this.updateDifference(newDate);
                }
            })
        );
    }

    private updateDifference(newDate: Date): void {
        this.selectedDate = newDate;
        const originalDate = new Date(this.data.originalDate);
        originalDate.setHours(0, 0, 0, 0);
        const selectedDate = new Date(newDate);
        selectedDate.setHours(0, 0, 0, 0);

        // Calculate difference in days
        const millisecondsPerDay = DAY_IN_MILLISECONDS;
        this.daysDifference = Math.round((selectedDate.getTime() - originalDate.getTime()) / millisecondsPerDay);

        this.newDateFormatted = Utils.formatDate(this.getLocalDateString(selectedDate), 'EEEE d MMMM', 'nl');
    }

    onConfirm(): void {
        if (this.selectedDate) {
            const result: ShiftDateRangeDialogResult = {
                newDate: this.getLocalDateString(this.selectedDate),
            };
            this.dialogRef.close(result);
        }
    }

    private getLocalDateString(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
